import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    maxRows: { type: Number, default: 5 }
  }

  connect() {
    this.resize()
  }

  resize() {
    if (!this.hasInputTarget) return

    const input = this.inputTarget
    const styles = window.getComputedStyle(input)
    const lineHeight = Number.parseFloat(styles.lineHeight) || 20
    const verticalPadding = Number.parseFloat(styles.paddingTop) + Number.parseFloat(styles.paddingBottom)
    const verticalBorder = Number.parseFloat(styles.borderTopWidth) + Number.parseFloat(styles.borderBottomWidth)
    const maxHeight = (lineHeight * this.maxRowsValue) + verticalPadding + verticalBorder

    input.style.height = "auto"
    input.style.height = `${Math.min(input.scrollHeight, maxHeight)}px`
    input.style.overflowY = input.scrollHeight > maxHeight ? "auto" : "hidden"
  }
}
